import { animated, useTrail } from "react-spring"
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome"
import React, { PropsWithChildren, useMemo } from "react"
import CircleContactButton from "../CircleContactButton/CircleContactButton"

export interface ContactInfo {
  icon: FontAwesomeIconProps["icon"]
  url: string
  color?: string
  bgColor?: string
  background?: string
  hoverColor?: string
}

export type AvatarWithContactButtonsProps = PropsWithChildren<{
  size: number
  contacts: ContactInfo[]
}>

export default function AnimatedContactButtons(props: AvatarWithContactButtonsProps) {
  const {
    children,
    size: avatarSize,
    contacts,
  } = props

  const contactsTrail = useTrail(contacts.length, {
    config: {
      mass: 2,
      friction: 25,
    },
    transform: "rotate(0deg)",
    // width: "calc(100% + 0px)",
    from: {
      transform: "rotate(90deg)",
      // width: "calc(100% + 480px)",
    },
  }).reverse()

  const contactsProps = useMemo(() => contactsTrail.map((trailProps, i) => (
    { trailProps, contact: contacts[i] }
  )), [contacts, contactsTrail])

  return (
    <div style={{
      width: `${avatarSize}%`,
      height: `${avatarSize}%`,
      minWidth: 128,
      minHeight: 128,
      transform: "translateY(0)",
    }}>
      <div>
        {children}
      </div>
      {contactsProps.map(({ trailProps, contact }, i) => (
        <div
          style={{
            top: `50%`,
            left: `50%`,
            width: `calc(100% + 80px)`,
            position: "fixed",
            transform: `
                        translate(-50%, -50%) 
                        rotate(${-(i - (contactsTrail.length - 1) / 2) * 28}deg)
                      `,
          }}
          key={i}
        >
          <animated.div style={trailProps}>
            <CircleContactButton href={contact.url} color={contact.bgColor} background={contact.background}>
              <FontAwesomeIcon icon={contact.icon} size='lg' color={contact.color}/>
            </CircleContactButton>
          </animated.div>
        </div>
      ))}
    </div>
  )
}
